import { Form, FormInstance } from "antd";

export const useWatchFormWithInit = (fieldName: string, form: FormInstance) => {
  const fieldNameWatch = Form.useWatch(fieldName, form);
  return fieldNameWatch || form.getFieldValue(fieldName);
};
